export const MOCK_INTEGRATIONS_RESPONSE = {
  results: [
    {
      id: 'mock-integration-1',
      name: 'Jira — Security Issues',
      provider: 'jira',
      is_active: true,
      field_mapping: {
        title: 'cve',
        description: 'description',
        priority: 'severity',
      },
      last_dispatched_at: '2024-11-15T09:00:00Z',
      created_at: '2024-10-01T00:00:00Z',
    },
    {
      id: 'mock-integration-2',
      name: 'Slack — Critical Alerts',
      provider: 'slack',
      is_active: true,
      field_mapping: {},
      last_dispatched_at: '2024-11-15T08:30:00Z',
      created_at: '2024-10-10T00:00:00Z',
    },
    {
      id: 'mock-integration-3',
      name: 'ServiceNow — Vuln Tickets',
      provider: 'servicenow',
      is_active: false,
      field_mapping: {},
      last_dispatched_at: null,
      created_at: '2024-11-01T00:00:00Z',
    },
  ],
  current_page: 1,
  total_pages: 1,
}
